import { createAction, props } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { Order } from '@rd/types/order.type';

export enum CheckoutOrderActionTypes {
  CHECKOUT_ORDER = '[OrderCheckout] Checkout Order',
  CHECKOUT_ORDER_SUCCESS = '[OrderCheckout] Checkout Order Success',
  CHECKOUT_ORDER_FAIL = '[OrderCheckout] Checkout Order Fail',
}

export const CheckoutOrder = createAction(
  CheckoutOrderActionTypes.CHECKOUT_ORDER,
);

export const CheckoutOrderSuccess = createAction(
  CheckoutOrderActionTypes.CHECKOUT_ORDER_SUCCESS,
  props<{ order: Order }>(),
);

export const CheckoutOrderFail = createAction(
  CheckoutOrderActionTypes.CHECKOUT_ORDER_FAIL,
  props<HttpError>(),
);
